import { render } from "./FormLocationText.vue?vue&type=template&id=2647fecd&ts=true"
import script from "./FormLocationText.vue?vue&type=script&lang=ts"
export * from "./FormLocationText.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__